import axios from "@/api/axiosInstance";
import { BillingInvoicePdf } from "./types";

const DEFAULT_FILE_NAME = "CertainPath-Invoice.pdf";

function extractFileName(contentDisposition: string | undefined): string {
  const match = contentDisposition?.match(/filename="(.+)"/);

  return match?.[1] ?? DEFAULT_FILE_NAME;
}

export const downloadBillingInvoicePdf = async (
  id: string,
): Promise<BillingInvoicePdf> => {
  const response = await axios.get<Blob>(
    `/api/private/billing/invoices/${id}/pdf`,
    { responseType: "blob" },
  );

  return {
    blob: response.data,
    fileName: extractFileName(response.headers["content-disposition"]),
  };
};